import React from "react";

const Modal = ({ open, title, message, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 text-center shadow-lg">
        <h2 className="mb-3 text-lg font-semibold text-gray-800">
          {title}
        </h2>

        <p className="text-sm text-gray-600">
          {message}
        </p>

        <button
          onClick={onClose}
          className="mt-6 w-full rounded-md bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default Modal;
